import React, { useContext, useState, useEffect } from 'react';
import { Users, DollarSign, Dribbble, BarChart, Cpu, LogIn, LogOut, Settings, Sun, Moon, MessageCircle, Zap, MessageSquare } from 'react-feather';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import { useTheme } from './ThemeContext';
import './navbar.css'
import brain from '../images/image.png'

function Navbar() {
  const { user, userProfile, logout } = useContext(AuthContext);
  const { isDarkMode, toggleTheme } = useTheme();
  const [windowDimension, setWindowDimension] = useState(null);
  const [showBetaMenu, setShowBetaMenu] = useState(false);
  const [showTbfMenu, setShowTbfMenu] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setWindowDimension(window.innerWidth);
  }, []);

  useEffect(() => {
    function handleResize() {
      setWindowDimension(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (showBetaMenu && !event.target.closest('.beta-menu-container')) {
        setShowBetaMenu(false);
      }
      if (showTbfMenu && !event.target.closest('.tbf-menu-container')) {
        setShowTbfMenu(false);
      }
    }
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [showBetaMenu, showTbfMenu]);

  const isMobile = windowDimension <= 640;

  const isActive = (path) => location.pathname === path;

  const getUserInitials = (name) => {
    if (!name) return 'U';
    return name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
  };

  const profile = userProfile;
  const profileLoading = user && !userProfile;
  return (
    <>
      {isMobile ? (
        <nav className='nav-mobile-wrapper'>
          <ul className='nav-mobile-menu'>
            <li className='nav-mobile-item tbf-menu-container'>
              <button 
                className={`nav-links tbf-trigger ${(isActive('/bets_home') || isActive('/investments') || isActive('/stats')) ? 'mobileactive' : ''}`}
                onClick={() => setShowTbfMenu(!showTbfMenu)}
              >
                <div className="tbf-icon-wrapper">
                  <span className="tbf-text">TBF</span>
                </div>
              </button>
              {showTbfMenu && (
                <div className="tbf-popup">
                  <Link 
                    to='/bets_home' 
                    className={`tbf-popup-item ${isActive('/bets_home') ? 'active' : ''}`}
                    onClick={() => setShowTbfMenu(false)}
                  >
                    <Dribbble size={18} className="tbf-popup-icon" />
                    <span>Bets</span>
                  </Link>
                  <Link 
                    to='/investments' 
                    className={`tbf-popup-item ${isActive('/investments') ? 'active' : ''}`}
                    onClick={() => setShowTbfMenu(false)}
                  >
                    <Users size={18} className="tbf-popup-icon" />
                    <span>Investors</span>
                  </Link>
                  <Link 
                    to='/stats' 
                    className={`tbf-popup-item ${isActive('/stats') ? 'active' : ''}`}
                    onClick={() => setShowTbfMenu(false)}
                  >
                    <BarChart size={18} className="tbf-popup-icon" />
                    <span>Stats</span>
                  </Link>
                </div>
              )}
            </li>
            <li className='nav-mobile-item'>
              <Link to='/exchange' className={`nav-links ${isActive('/exchange') ? 'mobileactive' : ''}`}>
                <DollarSign size={22} className="nav-icon" />
              </Link>
            </li>
            <li className='nav-mobile-item'>
              <Link to='/Schedule' className={`nav-links ${isActive('/Schedule') ? 'mobileactive' : ''}`}>
                <Cpu size={22} className="nav-icon" />
              </Link>
            </li>
            <li className='nav-mobile-item beta-menu-container'>
              <button 
                className={`nav-links beta-trigger ${(isActive('/crowd') || isActive('/lab') || isActive('/forum')) ? 'mobileactive' : ''}`}
                onClick={() => setShowBetaMenu(!showBetaMenu)}
              >
                <div className="beta-icon-wrapper">
                  <span className="beta-text">β</span>
                </div>
              </button>
              {showBetaMenu && (
                <div className="beta-popup">
                  <Link 
                    to='/crowd' 
                    className={`beta-popup-item ${isActive('/crowd') ? 'active' : ''}`}
                    onClick={() => setShowBetaMenu(false)}
                  >
                    <MessageCircle size={18} className="beta-popup-icon" />
                    <span>Crowd</span>
                    <span className="beta-popup-badge">BETA</span>
                  </Link>
                  <Link 
                    to='/lab' 
                    className={`beta-popup-item ${isActive('/lab') ? 'active' : ''}`}
                    onClick={() => setShowBetaMenu(false)}
                  >
                    <Zap size={18} className="beta-popup-icon" />
                    <span>Lab</span>
                    <span className="beta-popup-badge">BETA</span>
                  </Link>
                  <Link 
                    to='/forum' 
                    className={`beta-popup-item ${isActive('/forum') ? 'active' : ''}`}
                    onClick={() => setShowBetaMenu(false)}
                  >
                    <MessageSquare size={18} className="beta-popup-icon" />
                    <span>Forum</span>
                    <span className="beta-popup-badge">BETA</span>
                  </Link>
                </div>
              )}
            </li>
            <li className='nav-mobile-item'>
                {user ? (
                <>
                    <Link to="/myaccount" className={`nav-links ${isActive('/myaccount') ? 'mobileactive' : ''}`}>
                      <div className="nav-user-avatar-mobile">
                        {getUserInitials(profile?.name || user.id)}
                      </div>
                      <p className="nav-user-avail-mobile">${profile?.exchange_avail?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}</p>
                    </Link>
                </>
                ) : (
                <>
                  <Link to='/login' className={`nav-links ${isActive('/login') ? 'mobileactive' : ''}`}>
                    <LogIn size={22} className="nav-icon" />
                  </Link>
                </>
              )}
            </li>
          </ul>
        </nav>
      ) : (
        <nav className='nav-wrapper'>
          {/* Header */}
            <div className="nav-header">
            <Link to='/' className='nav-logo'>
              <img src={brain} alt="TB" className="nav-logo-icon" />
              <h1>The Brain</h1>
            </Link>
            <button className="theme-toggle-btn" onClick={toggleTheme} title={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}>
              {isDarkMode ? <Sun size={18} /> : <Moon size={18} />}
            </button>
          </div>          {/* Main Navigation */}
          <ul className='nav-menu'>
            <li className='nav-item'>
              <Link 
                to='/bets_home' 
                className={`nav-links ${isActive('/bets_home') ? 'active' : ''}`}
              >
                <Dribbble size={20} className="nav-icon" />
                Bets
                <span className="nav-tbf-badge">TBF</span>
              </Link>
            </li>
            <li className='nav-item'>
              <Link 
                to='/investments' 
                className={`nav-links ${isActive('/investments') ? 'active' : ''}`}
              >
                <Users size={20} className="nav-icon" />
                Investors
                <span className="nav-tbf-badge">TBF</span>
              </Link>
            </li>
            <li className='nav-item'>
              <Link 
                to='/stats' 
                className={`nav-links ${isActive('/stats') ? 'active' : ''}`}
              >
                <BarChart size={20} className="nav-icon" />
                Stats
                <span className="nav-tbf-badge">TBF</span>
              </Link>
            </li>
            <li className='nav-item'>
              <Link 
                to='/exchange' 
                className={`nav-links ${isActive('/exchange') ? 'active' : ''}`}
              >
                <DollarSign size={20} className="nav-icon" />
                Exchange
              </Link>
            </li>
            <li className='nav-item'>
              <Link 
                to='/Schedule' 
                className={`nav-links ${isActive('/Schedule') ? 'active' : ''}`}
              >
                <Cpu size={20} className="nav-icon" />
                Model
              </Link>
            </li>
            <li className='nav-item'>
              <Link 
                to='/crowd' 
                className={`nav-links ${isActive('/crowd') ? 'active' : ''}`}
              >
                <MessageCircle size={20} className="nav-icon" />
                Crowd
                <span className="nav-beta-badge">BETA</span>
              </Link>
            </li>
            <li className='nav-item'>
              <Link 
                to='/lab' 
                className={`nav-links ${isActive('/lab') ? 'active' : ''}`}
              >
                <Zap size={20} className="nav-icon" />
                Lab
                <span className="nav-beta-badge">BETA</span>
              </Link>
            </li>
            <li className='nav-item'>
              <Link 
                to='/forum' 
                className={`nav-links ${isActive('/forum') ? 'active' : ''}`}
              >
                <MessageSquare size={20} className="nav-icon" />
                Forum
                <span className="nav-beta-badge">BETA</span>
              </Link>
            </li>
          </ul>

          {/* Footer */}
          <div className="nav-footer">
            {user ? (
              <>
                <Link to="/myaccount" className="nav-user-info" style={{ textDecoration: 'none' }}>
                  <div className="nav-user-avatar">
                    {getUserInitials(profile?.name || user.id)}
                  </div>
                  <div className="nav-user-details">
                    <p className="nav-user-name">
                      {profileLoading ? 'Loading...' : (profile?.name || 'User')}
                    </p>
                    <p className="nav-user-avail">${profile?.exchange_avail?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}</p>
                    <p className="nav-user-email">{profile?.email || user.id}</p>
                  </div>
                </Link>
                <button className="nav-logout" onClick={logout} title="Logout">
                  <LogOut size={16} />
                </button>
              </>
            ) : (
              <Link to='/login' className='nav-links'>
                <LogIn size={20} className="nav-icon" />
                Login
              </Link>
            )}
          </div>
        </nav>
      )}
    </>
  )
}

export default Navbar